import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Select2UpdateEvent, Select2Value } from 'ng-select2-component';
import { FormBuilder, FormControl, FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';
import { InputSelect2Interface } from '@shared/components/form/input-select2/input-select2.interface';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-input-select2',
  templateUrl: './input-select2.component.html',
  styleUrls: ['./input-select2.component.scss'],
})
export class InputSelect2Component implements OnInit {
  @Input() label: string;
  @Input() value: Select2Value;
  @Input() required = false;
  @Input() disableSelect: boolean = false;
  @Input() placeholder: string = 'Pilih salah satu';
  @Input() options: InputSelect2Interface[];
  @Input() optionsObservable: BehaviorSubject<InputSelect2Interface[]> = new BehaviorSubject<InputSelect2Interface[]>([]);
  @Input() class?: string;
  @Input() behaviorSubjectOptions: string;
  @Input() customNameWithId = false;
  @Output() handleChangeData = new EventEmitter();
  @Input() disabledValue?: BehaviorSubject<string[]>;
  @Input() maxHeight: string;
  valueFormGroup?: FormGroup;
  valueFormControl?: FormControl;
  disable: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  // fbInputSelect2: FormGroup = this.formBuilder.group({
  //   formInput: [''],
  // });

  constructor(private formGroupDirective: FormGroupDirective, private formControlNameDirective: FormControlName, private formBuilder: FormBuilder) {}

  ngOnInit() {
    if (this.disabledValue) {
      this.disabledValue.subscribe((result) => {
        this.disable.next(result);
      });
    }

    this.valueFormGroup = this.formGroupDirective.form;
    this.valueFormControl = this.formGroupDirective.getControl(this.formControlNameDirective);

    // possibly not being used
    // remove comment if any component use causing error.
    // this.optionsObservable.subscribe((value1) => {
    //   if (value1.length > 0) {
    //     this.options = value1;
    //   }
    // });

    this.valueFormControl.patchValue(this.value);
  }

  get controlName() {
    return this.formControlNameDirective.name;
  }

  get enabled() {
    return this.valueFormControl?.enabled;
  }

  get isNotValidAndDirty() {
    return !this.formControlNameDirective.valid && this.formControlNameDirective.dirty;
  }

  get hasErrors() {
    return this.formControlNameDirective.errors;
  }

  handleChangeValue(e: Select2UpdateEvent) {
    if (!e.value) {
      return;
    }

    this.options.map((value) => {
      value.disabled = false;
      this.disable.value.map((disable) => {
        if (value.value === disable) {
          value.disabled = true;
        }
      });
    });

    if (this.valueFormControl) this.valueFormControl.patchValue(e.value);
    this.handleChangeData.emit(e.value);
  }
}
